export default __webpack_public_path__ + "static/media/Coco-Cow-animation.7b881224.png";